import Cookies from "js-cookie";
import api from "./apiService";

// ? token
export const getToken = () => Cookies.get("token");

// ? Base URL

export const BASE_URL = process.env.REACT_APP_ENDPOINT;

// Decode JWT token payload
export const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

// Get user object from token

export const getDecodedUser = () => {
  const token = getToken();
  if (!token) return null;
  return parseJwt(token);
};

export const getUser = async () => {
  const decoded = getDecodedUser();
  const userId = decoded?.id || decoded?._id;
  if (!userId) return null;
  try {
    const res = await api.get(`/users/getUser/${userId}`);
    if (res.error) {
      console.error(res.error);
      return null;
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
